<template>
  <div>
    <b-container>
      <b-row class="d-md-none">
        <div class="position-fixed zIndex">
          <b-button v-b-toggle.sidebar-right>
            <b-icon icon="justify"></b-icon>
          </b-button>
          <b-sidebar id="sidebar-right" title="" right shadow>
            <div class="px-3 py-2">
              <filters/>
            </div>
          </b-sidebar>
        </div>
      </b-row>

      <b-row>
        <b-col md="3" lg="3" class="d-none d-md-block">
          <filters/>
        </b-col>
        <b-col cols="12" sm="12" md="9" lg="9">
          <b-row class="border mb-3" >
            <b-nav pills>
              <b-nav-item disabled>مرتب سازی بر اساس:</b-nav-item>
              <b-nav-item
                  id="navBg1"
                  class="rounded-lg"
                  @click="filterBySortOrder('asc')"
                  :active="$route.query.sort == 'asc'"
              >
                <span id="navTx1" class="">ارزان ترین </span></b-nav-item
              >
              <b-nav-item
                  id="navBg2"
                  class="rounded-lg"
                  @click="filterBySortOrder('desc')"
                  :active="$route.query.sort == 'desc'"
              >
                <span id="navTx2" class=""> گران ترین </span>
              </b-nav-item>
            </b-nav>
          </b-row>
          <b-row>
            <product-card
                v-for="product in items"
                :key="product.id"
                :product="product"
            />
          </b-row>

          <b-row class="pt-3 mt-3">
            <m-pagination-400
                v-if="havePagination"
                :meta="paginationMeta"
                :on-change-page="changePageFunction"
            />
            <slot name="more"></slot>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import router from "@/router";
import Filters from './Filters'
import ProductCard from './ProductCard'

export default {
  name: "ProductsList",
  components: {Filters, ProductCard},
  props: ["havePagination"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      paginationMeta: "Product/getPaginationMeta",
      items: 'Product/getProducts'
    }),
  },
  watch: {},

  async mounted() {
    const sort = await router.currentRoute.query.sort;
    sort != undefined
        ? await this.$store.commit("Product/setFilters", {
          key: "sort",
          value: sort,
        })
        : "";


    const search = await router.currentRoute.query.search;
    search != undefined
        ? await this.$store.commit("Product/setFilters", {
          key: "search",
          value: search,
        })
        : "";

    await this.$store.commit('Product/setProducts', 1)
  },
  methods: {
    filterBySortOrder(order) {
      this.$store.commit("Product/setFilters", {
        key: "sort",
        value: order,
      });
      router.push({
        name: "Products",
        query: {...router.currentRoute.query, sort: order},
      });
      this.filterAction();
    },
    filterAction() {
      if (
          this.$store.getters["Product/getFilter"]("search").trim().length == 0
      ) {
        this.$store.dispatch("Product/setProducts", 1);
      } else {
        this.$store.dispatch("Product/filteredProducts");
      }
    },
    changePageFunction(page) {
      this.$store.dispatch("Product/setProducts", page);
    },
  },
};
</script>

<style scoped>
.zIndex {
  z-index: 1000;
}
</style>